import { IconButton, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const MenuButton = styled(IconButton, {
  name: actionBarName,
  overridesResolver: (_props, styles) => [styles.menuButton],
  slot: "MenuButton"
})``;
export {
  MenuButton
};
//# sourceMappingURL=MenuButton.js.map
